import React from "react";
import BlogTwenty from "../component/BlogTwenty";

function BlogTwentyContainer() {
  return <BlogTwenty />;
}
export default BlogTwentyContainer;
